import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { Footer } from "@/components/Footer";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Landing";
import Estate from "@/pages/Estate";
import Category from "@/pages/Category";
import Project from "@/pages/Project";
import Contact from "@/pages/Contact";
import History from "@/pages/History";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <div className="grain min-h-screen bg-ivory text-heritage">
        <SiteHeader />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/estate" element={<Estate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/history" element={<History />} />
            <Route path="/:category" element={<Category />} />
            <Route path="/:category/:project" element={<Project />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
